module.exports = __webpack_public_path__ + "static/media/mountains.ce701f9e.jpg";